












































































import BaseFormMixin from '@/mixins/base-form-mixin';
import { DatasourceDto } from '@/services/datasource';
import { mixins } from 'vue-class-component';
import { Component, PropSync, Prop, Watch } from 'vue-property-decorator';

@Component
export default class DatasourceFormTab1 extends mixins(BaseFormMixin) {
  @PropSync('formData') syncFormData!: DatasourceDto;
  @Prop() id!: any;
  @Prop() dsCategory!: string;
  @Prop() dsType!: string;

  mounted() {}

  changeDBType(key: string) {
    // 更新时不修改
    if (!this.id) {
      this.syncFormData.dsType = key;
      this.syncFormData.dsCategory = this.dsCategory;
    }
  }

  callback(key: any) {
    // 更新时不修改
    if (!this.id) {
      this.syncFormData.dsCategory = key;
      this.syncFormData.dsType = '';
    }
  }

  // @Watch("dsCategory")
  // onChangeDsCategory() {
  //   debugger
  //   this.dsType = '';
  //   this.syncFormData.dsCategory = this.dsCategory;
  // }

}
